import * as React from "react";

export interface IButtonProps {
  itemID?: string;
  cssID: string;
  disabled: boolean;
  fontawesomeIconCSS: string;
  text: string;
  visibleText?: boolean;
  tabIndex?: number;
  onClick: (event: any) => any;
  onFocussed?: (itemID: string) => any;
  removeJsNavSystem?: boolean;
  isCMSButton?: boolean;
  tooltipTextOnFocus?: string;
}

export const Button = (props: IButtonProps) => {

  let visText = "";

  let baseBtnClass = "";
  let sqrBtnClass = "";
  if (props.isCMSButton) {
    baseBtnClass = "CMS_button";
    sqrBtnClass = "CMS_bSquare";
  } else {
    baseBtnClass = "CAL-button";
    sqrBtnClass = "CAL-square";
  }

  let anchorCSSclasses = baseBtnClass;

  if (props.visibleText) {
    visText = props.text;
  } else {
    anchorCSSclasses += " " + sqrBtnClass;
  }

  if (!props.removeJsNavSystem) { anchorCSSclasses += " js-nav-system__link"; }

  if (props.cssID) { anchorCSSclasses += " " + props.cssID; }
  if (props.disabled) { anchorCSSclasses += " CMS_bDisabled"; }

  let emCSSclasses = "fa";
  if (props.fontawesomeIconCSS) { emCSSclasses += " " + props.fontawesomeIconCSS; }

  let onClick = props.onClick;
  if (props.disabled) { onClick = null; }

  let dataTooltip: string = null;
  if (props.tooltipTextOnFocus) {
    dataTooltip = props.tooltipTextOnFocus.trim();
  }

  const onFocus = () => { if (props.onFocussed) { props.onFocussed(props.itemID); } };

  return (
    <a className={anchorCSSclasses} href="#!" onClick={onClick} title={props.text} data-tooltip={dataTooltip} tabIndex={props.tabIndex} onFocus={onFocus}><span className="offScreen">{props.text}</span><em className={emCSSclasses} aria-hidden="true"></em> {visText}</a>
  );
};
